<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-descriptions direction="horizontal" :column="1">
      <el-descriptions-item label="优惠券名称">{{ form.name }}</el-descriptions-item>
      <el-descriptions-item label="优惠规则">{{ `订单满${form.limitPrice}元减${form.price}元` }}</el-descriptions-item>
      <el-descriptions-item label="发放总量">{{ form.num }}张</el-descriptions-item>
      <el-descriptions-item label="兑换条件">
        {{ form.integral }} 咖豆兑换一张优惠券
      </el-descriptions-item>
      <el-descriptions-item label="可领时间">{{ `${form.startDate}至${form.endDate}` }}</el-descriptions-item>
      <el-descriptions-item label="可用时间">{{ `领券后${form.validDays}天有效` }}</el-descriptions-item>
    </el-descriptions>
    <div slot="footer"></div>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaCouponWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    
    return {
      getDate: [],
      // 表单数据
      form: {
        id: null,
        name: '',
        shopId: '',
        type: '',
        limitPrice: '',
        price: '',
        startDate: '',
        endDate: '',
        validDays: '',
        getMethod: '',
        integral: '',
        status: '',
        num: '',
        info: ''
      },
      
    }
  },
  created () {
    this.config({
      api: '/business/coupon',
      'field.id': 'id'
    })
  },
  methods: {
    
  },
}
</script>

<style lang="scss" scoped>
</style>
